import accountModule from './account-module'
import devicesModule from './devices-module'
import customersModule from './customers-module'
import usersModule from './users-module'

export default {
  modules: {
    account: accountModule,
    devices: devicesModule,
    customers: customersModule,
    users: usersModule
    // transactions: transactionsModule,
    // news: newsModule,
    // dashboard: dashboardModule,
    // portfolio: portfolioModule,
    // referral: referralModule,
    // literals: leteralsModule
  },
  state: {
    device: '',
    popups: new Set(),
    monthDictionary: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ]
  },
  mutations: {

    checkDevice (state, device) {
      state.device = device
    },
    openPopup (state, uuid) {
      state.popups.add(uuid)
      if (document.body) document.body.classList.add('popup-opened')
    },
    closePopup (state, uuid) {
      state.popups.delete(uuid)
      if (state.popups.size === 0 && document.body) {
        document.body.classList.remove('popup-opened')
      }
    },
    setMonthDictionary (state, dictionary) {
      state.monthDictionary = dictionary
    }
  },
  actions: {
    reset ({commit}, {store}) {
      Object.keys(store._modulesNamespaceMap).forEach(key => commit(`${key}reset`))
    },
    setMonthDictionaryHandler (context) {
      /** get month dictionaries here */
      // context.commit('setMonthDictionary', dictionary)
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/index.js